import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight } from 'lucide-react';

const CheckoutCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-20 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center px-6 max-w-lg"
      >
        <div className="w-24 h-24 bg-[#A3988F]/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <XCircle className="w-12 h-12 text-[#A3988F]" />
        </div>
        <h1 className="font-serif text-4xl text-[#F5F2EB] mb-4">Payment Cancelled</h1>
        <p className="text-[#A3988F] mb-8">
          Your payment was cancelled. Your cart items are still saved if you'd like to complete your purchase.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/cart" className="btn-primary inline-flex items-center justify-center space-x-2" data-testid="return-cart-btn">
            <span>Return to Cart</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/fashion" className="btn-secondary inline-flex items-center justify-center space-x-2" data-testid="continue-shopping-btn">
            <span>Continue Shopping</span>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default CheckoutCancelPage;
